<template>
    <div class="container" >
        <div class="row justify-content-between my-3">
            <div class="col text-center"><h2>Санал асуулгууд</h2></div>

        </div>
        <div class= "row" v-if="schools!=null && schools.length>0">
            <div class="col-sm-12 col-md-4  my-2" v-for="(q, index) in schools" v-bind:key="q.id">
                <div class="card-deck  h-100">
                    <div  class="card shadow-sm mb-4 h-100">
                        <div class="card-header py-3">
                            <div class="row justify-content-between">
                                <div class="col col-12">
                                    <h5 class="m-0 font-weight-bold text-primary" style="cursor:pointer">{{index+1}}.  {{q.name}}</h5>
                                </div>
                                <div class="col col-12">
                                    <span v-if="q.public==true" class="badge badge-success">нээлттэй</span>
                                    <span v-else class="badge badge-danger">хаалттай</span>
                                    
                                </div>

                            </div>
                        </div>
                        <div class="card-body">
                            <span v-if="q.code" class="text-primary">/{{q.code}}/</span> 
                            <p style="white-space: pre-wrap" v-if="q.description!=null" v-html="q.description"></p>
                            
                            
                        </div>  
                        <div class="card-footer" v-if="q && q.link">
                            <div class="row">
                
                                <!-- <div class="col col-md-6 pull-right">
                                    <div class="float-right">
                                        <button @click="goDetail(q.link)" class=" btn  btn-lg btn-success mr-2 btn-sm" >Санал өгөх</button>
                                    </div>
                                
                                </div> -->
                                <div class="col col-md-6 pull-left">
                                    <div class="float-left">
                                        <button v-if="q.public!=true" @click="setProp(q, true)" class=" btn  btn-lg btn-primary mr-2 btn-sm" >Асуулга нээх</button>
                                        <button v-else @click="setProp(q, false)" class=" btn  btn-lg btn-danger mr-2 btn-sm" >Асуулга хаах</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="alert alert-info text-center">Одоогоор нээлттэй явагдаж байгаа асуулга байхгүй байна.</div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
                schools:[],
                departments:[],
                object:{
                    name:'',
                    shortName:'',
                    description:'',
                    university:false

                },

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            _getQA(){
                fb.db.collection("asuulgalinks").orderBy("index").onSnapshot(querySnapshot=> {
                    this.schools=[];
                    querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id;
                            this.schools.push(object);
                    });
                });

            },
            goDetail(link){
                location.href = link+'?yuneljd='+this.currentUser.uid;
            },
            setProp(qa, value){
                if(value==true){
                    var r = confirm("Та "+qa.name+" асуулгыг нээлттэй болгох уу? Нээлттэй болгосноор багш нар энэ асуулгад хариулах боломжтой болно.");
                    if (r == true) {
                        fb.db.collection("asuulgalinks").doc(qa.id).update({public: true});
                    }
                }
                else{
                    var r = confirm("Та "+qa.name+" асуулгыг хаалттай болгох уу? Хаалттай болгосноор багш нар энэ асуулгад хариулах боломжгүй болно.");
                    if (r == true) {
                        fb.db.collection("asuulgalinks").doc(qa.id).update({public: false});
                    }
                }
            }
       
  
        },
        created() {
            var _this=this;

            this._getQA();
                
        },
        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
